export default [
  {
    title: "案件主体",
    link: "subjectActionManage",
    key: "accsuer:index",
    cur: "3-2",
    other: true,
  },
  {
    title: "业务部门",
    link: "team",
    key: "team:index",
    cur: "3-6",
    other: true,
  },
  {
    title: "代理模式",
    link: "agency",
    key: "agency:index",
    cur: "3-z",
    other: true,
  },
  {
    title: "进度期限",
    link: "over",
    key: "over:index",
    cur: "3-5",
    other: true,
  },
  {
    title: "业务类型",
    link: "allCar",
    key: "car:index",
    cur: "3-3",
    other: true,
  },
  {
    title: "案件案由",
    link: "action",
    key: "reason:index",
    cur: "3-4",
    other: true,
  },
  {
    title: "金融机构",
    link: "bank",
    key: "bank:index",
    other: true,
    cur: "3-7",
  },
  {
    title: "仲裁目录",
    link: "ArbList",
    key: "arbitrate:index",
    other: true,
    cur: "3-8",
  },
];
